import { FEE_TYPES } from "../endpoints";
import api from "../api";

export default {
    index() {
        return api.get(FEE_TYPES);
    }
}